import React from 'react';
import { cornerBanner } from '../config/siteConfig';

const CornerBanner = () => {
  // Don't render if banner is disabled
  if (!cornerBanner.enabled) return null;

  const bannerContent = (
    <img
      src={cornerBanner.image}
      alt={cornerBanner.alt}
      className="w-[259px] sm:w-[288px] md:w-[346px] h-auto hover:scale-105 transition-transform duration-300"
    />
  );

  return (
    <div className="fixed top-16 right-0 z-40 pointer-events-auto translate-x-[15px] -translate-y-[15px]">
      {cornerBanner.link ? (
        <a 
          href={cornerBanner.link}
          target="_blank"
          rel="noopener noreferrer"
          className="block"
        >
          {bannerContent}
        </a>
      ) : (
        bannerContent
      )}
    </div>
  );
};

export default CornerBanner;
